module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = 5